import type { FormEvent } from "react";
import { Alerta, Button, Row, Select, Stack, TextField } from "@/components";
import type { TipoComprador } from "@/lib/api";
import { OPCIONES_TIPO_COMPRADOR, type ErroresComprador, type FormComprador } from "@/lib/ventas";

export interface FormularioCompradorProps {
  form: FormComprador;
  cambiar: <K extends keyof FormComprador>(campo: K, valor: FormComprador[K]) => void;
  errores: ErroresComprador;
  onSubmit: (e: FormEvent) => void;
  onCancelar: () => void;
  guardando: boolean;
  error: string | null;
  textoGuardar: string;
}

/** Campos del comprador (alta y edición). Sin `<Dialog>`: lo envuelve quien lo usa. */
export function FormularioComprador({ form, cambiar, errores, onSubmit, onCancelar, guardando, error, textoGuardar }: FormularioCompradorProps) {
  return (
    <form onSubmit={onSubmit} noValidate>
      <Stack espacio={4}>
        <Select etiqueta="Tipo" opciones={OPCIONES_TIPO_COMPRADOR} valor={form.tipo} onCambio={(v) => cambiar("tipo", v as TipoComprador)} />
        <TextField etiqueta="Nombre" value={form.nombre} onChange={(e) => cambiar("nombre", e.target.value)} error={errores.nombre} />
        <TextField etiqueta="Documento" ayuda="DNI o CUIT, con o sin puntos" value={form.documento} onChange={(e) => cambiar("documento", e.target.value)} error={errores.documento} />
        <Row espacio={3} envolver>
          <TextField etiqueta="Email" type="email" value={form.email} onChange={(e) => cambiar("email", e.target.value)} error={errores.email} contenedorClassName="flex-1" />
          <TextField etiqueta="Teléfono" type="tel" value={form.telefono} onChange={(e) => cambiar("telefono", e.target.value)} error={errores.telefono} contenedorClassName="flex-1" />
        </Row>
        <TextField etiqueta="Domicilio" value={form.domicilio} onChange={(e) => cambiar("domicilio", e.target.value)} error={errores.domicilio} />
        <TextField etiqueta="Notas" value={form.notas} onChange={(e) => cambiar("notas", e.target.value)} error={errores.notas} />
        <Alerta texto={error} />
        <Row justificar="fin" espacio={2}>
          <Button variante="secundario" onClick={onCancelar}>
            Cancelar
          </Button>
          <Button type="submit" cargando={guardando}>
            {textoGuardar}
          </Button>
        </Row>
      </Stack>
    </form>
  );
}
